import React, { useState, useEffect } from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import {
    Navbar,
    Nav,
    Container,
    Row,
    Card,
    Col,
    Button
} from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../styles/navbar.css';
import MediaDiet from './MediaDiet/MediaDiet';
import HomePage from './Home/home';
import SurveyPage from './Survey/survey';
import ConsentPage from './Consent/consent';
import CallBackPage from './Callback/callback';
import MyProfilePage from './Profile/MyProfile';
import StartSurvey from './RegularSurvey/';
import ElaborateSurvey from './ElaborateSurvey';
import AddEmailPopUp from './Profile/AddEmailPopUp';
import axiosInterceptor from '../services/axiosInterceptor';
import TrackConversionPage from './Callback/trackConversion';
import BugReportPage from './BugReport';

const Navigation = () => {
    const history = useHistory();
    const location = useLocation();

    const [loggedOut, setLoggedOut] = useState(true);
    const [isMainSite, setIsMainSite] = useState(false);
    const [isEmailPopUp, setEmailPopUp] = useState(false);
    const [emailLabel, setEmailLabel] = useState('');
    const [emailCollected, setEmailCollected] = useState('no');
    const [authCookie, setAuthCookie, removeAuthCookie] = useCookies([
        'oauth_token',
        'access_token',
        'email_collected'
    ]);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        if (authCookie?.oauth_token) {
            setLoggedOut(false);
            let i = 0;
            const interval = setInterval(() => {
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <Card
                                style={{ width: '25rem', height: '10rem' }}
                                className="confirmCard"
                            >
                                <Card.Body>
                                    <Card.Title>Session Expired</Card.Title>
                                    <Card.Text>
                                        Session expired. Please Login again.
                                    </Card.Text>
                                    <Container fluid>
                                        <Row>
                                            <Col xs={6} className="text-left">
                                                <Button
                                                    variant="outline-success"
                                                    className="w-100"
                                                    onClick={() => {
                                                        logout();

                                                        if (history) {
                                                            history.push('/');
                                                        } else {
                                                            window.location =
                                                                '/';
                                                        }
                                                        onClose();
                                                    }}
                                                >
                                                    OK
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                        );
                    }
                });

                i += 1;
                if (i === 1) {
                    clearInterval(interval);
                }
            }, 86400 * 1000);
        } else {
            setLoggedOut(true);
        }
    }, []);

    useEffect(() => {
        //TODO: Remove
        // history.push('/consent');

        if (location.pathname != '/consent' && location.pathname != '/') {
            setIsMainSite(true);
        } else {
            setIsMainSite(false);
        }

        if (location.pathname === '/bugreport') {
            history.push('/bugreport');
            return;
        }

        if (location.pathname != '/' && !authCookie?.oauth_token) {
            history.push('/');
        }
        if (
            location.pathname != '/' &&
            location.pathname != '/consent' &&
            location.pathname != '/callback' &&
            !authCookie?.access_token
        ) {
            history.push('/');
        }

        if (
            (location.pathname == '/' ||
                location.pathname == '/consent' ||
                location.pathname == '/callback') &&
            authCookie?.access_token
        ) {
            if (loggedOut) {
                history.push('/survey');
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        if (authCookie?.email_collected == 'true') {
            setEmailCollected('yes');
        } else {
            setEmailCollected('no');
        }
    }, [authCookie]);

    // Check Whether User added Email or not. If Yes, direct Logout otherwise show Add Email Popup
    const clickLogout = async () => {
        // await emailPopUp();
        // if (isEmailPopUp) {
        //     logout();
        // }
        if (emailCollected != 'no') {
            logout();
        } else {
            setEmailLabel('Logout');
            emailPopUp();
        }
    };

    // Logout Functionality
    const logout = () => {
        (async () => {
            try {
                await axiosInterceptor().post('twitter/auth/logout', {
                    oauth_token: authCookie?.oauth_token
                });
                removeAuthCookie('oauth_token');
                removeAuthCookie('access_token');
                removeAuthCookie('email_collected');
                localStorage.removeItem('twclid');
                localStorage.removeItem('return_token');
                setLoggedOut(true);
                history.push('/');
            } catch (error) {
                console.error(error);
            }
        })();
    };

    // Email PopUp for Adding Email to the User Object
    const emailPopUp = () => {
        setEmailPopUp(!isEmailPopUp);
    };

    return (
        <Container fluid className="text-center">
            <Row className="mb-3 mt-5">
                <Navbar
                    bg="dark"
                    expand="md"
                    variant="dark"
                    fixed="top"
                    expanded={expanded}
                    collapseOnSelect
                >
                    {location.pathname != '/' &&
                        location.pathname != '/callback' && (
                            <Navbar.Toggle
                                aria-controls="responsive-navbar-nav"
                                className="ml-auto"
                                onClick={() =>
                                    setExpanded(expanded ? false : 'expanded')
                                }
                            />
                        )}

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav
                            className="mr-auto"
                            style={
                                expanded
                                    ? { background: 'rgb(48, 67, 79)' }
                                    : { background: 'none' }
                            }
                        >
                            {!loggedOut &&
                                isMainSite &&
                                location.pathname != '/callback' && (
                                    <NavLink
                                        to="/survey"
                                        exact
                                        className="nav-link-class"
                                        onClick={() => setExpanded(false)}
                                    >
                                        <FormattedMessage
                                            id="Navigation.home"
                                            defaultMessage="Home"
                                        />
                                    </NavLink>
                                )}
                        </Nav>
                        <Nav
                            className="ml-auto"
                            style={
                                expanded
                                    ? { background: 'rgb(48, 67, 79)' }
                                    : { background: 'none' }
                            }
                        >
                            {!loggedOut && location.pathname != '/' && (
                                <>
                                    {location.pathname != '/consent' &&
                                        location.pathname != '/callback' &&
                                        emailCollected != 'yes' && (
                                            <a
                                                className="nav-link-class emailClass"
                                                onClick={() => {
                                                    emailPopUp();
                                                    setEmailLabel('Add');
                                                }}
                                            >
                                                <FormattedMessage
                                                    id="Navigation.addEmail"
                                                    defaultMessage="Add Email"
                                                />
                                            </a>
                                        )}
                                    <NavLink
                                        to="/bugreport"
                                        className="nav-link-class logoutClass"
                                        style={{ textDecoration: 'none ' }}
                                        exact
                                        onClick={() => setExpanded(false)}
                                    >
                                        <FormattedMessage
                                            id="Navigation.reportBug"
                                            defaultMessage="Report Bug"
                                        />
                                    </NavLink>
                                    {location.pathname != '/consent' &&
                                        location.pathname != '/callback' && (
                                            <NavLink
                                                onClick={() =>
                                                    setExpanded(false)
                                                }
                                                to="/myProfile"
                                                className="nav-link-class logoutClass"
                                                // style={{ textDecoration: 'none ' }}
                                                exact
                                            >
                                                <FormattedMessage
                                                    id="Navigation.myProfile"
                                                    defaultMessage="My Profile"
                                                />
                                            </NavLink>
                                        )}
                                    {location.pathname != '/callback' && (
                                        <a
                                            onClick={() => {
                                                clickLogout();
                                                setExpanded(false);
                                            }}
                                            className="nav-link-class logoutClass"
                                            style={{ textDecoration: 'none ' }}
                                            exact
                                        >
                                            <FormattedMessage
                                                id="Navigation.logout"
                                                defaultMessage="Logout"
                                            />
                                        </a>
                                    )}
                                </>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Row>
            <Row>
                {isEmailPopUp && (
                    <AddEmailPopUp
                        emailPopUp={emailPopUp}
                        emailLabel={emailLabel}
                        logout={logout}
                    />
                )}
                <Switch>
                    <Route exact path="/">
                        <HomePage />
                    </Route>
                    <Route path="/bugreport">
                        <BugReportPage />
                    </Route>
                    <Route path="/consent">
                        <ConsentPage />
                    </Route>
                    <Route path="/callback">
                        <CallBackPage />
                    </Route>
                    <Route path="/conversion">
                        <TrackConversionPage />
                    </Route>
                    <Route path="/survey">
                        <SurveyPage />
                    </Route>
                    <Route path="/myProfile">
                        <MyProfilePage logout={logout} />
                    </Route>
                    <Route path="/start/media_diet">
                        <MediaDiet />
                    </Route>
                    <Route path="/start/elaborate">
                        <ElaborateSurvey />
                    </Route>
                    <Route path="/start/:id">
                        <StartSurvey />
                    </Route>
                </Switch>
            </Row>
        </Container>
    );
};

export default withRouter(Navigation);
